import React from 'react';

function App() {
  return (
    <div className="App">
      <header className="App-header" style={{ 
        textAlign: 'center', 
        padding: '50px',
        backgroundColor: '#282c34',
        color: 'white',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <h1>FASLT - Leadership Assessment Tool</h1>
        <p>Feedback Audit Assessment for Senior Tech Leaders</p>
        <p>Initial setup successful!</p>
      </header>
    </div>
  );
}

export default App;
